/**
 * Route definition for /contact
 * Renders the ContactContainer component.
 *
 * @module routes/contact
 * @category Routes
 */
import { createFileRoute } from '@tanstack/react-router'
import ContactContainer from '@/containers/Contact'

export const Route = createFileRoute('/$locale/contact')({
  component: Contact,
})

/**
 * Contact page component.
 * Renders the Contact container for user inquiries and support.
 *
 * @returns {React.ReactElement}
 */
function Contact() {
  return (
    <ContactContainer />
  )
}